module.exports = __webpack_public_path__ + "static/Wszystko-juz-bylo-MSN-294a73b41fb69466b0e3333bae2ecb84.png";